/** Entry point for the `/preview/` page. */

import './base.js';

import { main } from '../../client/preview.js';

void main();
